/*
  CFG - Father's Day Sale Modal controller
  Lightweight overlay opened by any [data-fd-open] trigger.
*/
(function () {
  var modal = document.getElementById('fd-modal');
  if (!modal) return;

  var overlay = modal.querySelector('.fd-modal__overlay');
  var closeBtns = modal.querySelectorAll('[data-fd-close]');
  var previouslyFocused = null;

  function openModal() {
    if (!modal.hasAttribute('hidden')) return;
    previouslyFocused = document.activeElement;
    modal.removeAttribute('hidden');
    document.body.classList.add('fd-modal-open');
    var focusTarget = modal.querySelector('[data-fd-close]') || modal;
    setTimeout(function () { focusTarget.focus && focusTarget.focus(); }, 0);
  }

  function closeModal() {
    if (modal.hasAttribute('hidden')) return;
    modal.setAttribute('hidden', '');
    document.body.classList.remove('fd-modal-open');
    if (previouslyFocused && previouslyFocused.focus) {
      previouslyFocused.focus();
    }
  }

  // Open triggers anywhere on the page
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-fd-open]');
    if (trigger) {
      e.preventDefault();
      openModal();
    }
  });

  // Close on overlay or close buttons
  if (overlay) overlay.addEventListener('click', closeModal);
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeModal); });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // Keyboard open support for focusable triggers (Enter / Space)
  document.addEventListener('keydown', function (e) {
    var active = document.activeElement;
    if (!active) return;
    if (active.closest && active.closest('[data-fd-open]') && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      openModal();
    }
  });
})();
